import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import { buildQueryParams } from '@/hooks/api/helpers';
import type { FanguardApiContractsUserUserDetailModel } from 'src/api/generated';
import type { PagedResponse } from 'src/types/GlobalTypes';

export const USERS_URI = 'users';

export const usersQueries = createQueryKeys(USERS_URI, {
  all: null,
  current: (username: string) => ({
    queryKey: [username],
    queryFn: async () => {
      const response = await get<FanguardApiContractsUserUserDetailModel>({
        uri: `${USERS_URI}/${username}`,
      });
      return response.data;
    },
  }),
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsUserUserDetailModel>({
        uri: `${USERS_URI}/${id}`,
      });
      return response.data;
    },
  }),
  list: (params: { page?: number; pageSize?: number; searchTerm?: string }) => {
    const page = params.page ?? 1;
    const pageSize = params.pageSize ?? 25;
    const searchTerm = params.searchTerm ?? '';
    return {
      queryKey: [{ page, pageSize, searchTerm }],
      queryFn: async () => {
        const response = await get<PagedResponse<FanguardApiContractsUserUserDetailModel>>({
          uri: `${USERS_URI}?${buildQueryParams({ page, pageSize, searchTerm })}`,
        });
        return response.data;
      },
    };
  },
  config: null,
});
